jQuery(document).ready(function() {


  
// Custom JS functions

    //toggle forms
    /*$('.init-toggle-form').click(function() {
        $('.init-toggle-form, .toggle-form').removeClass('active');
        $(this).addClass('active');
        
        var form_number = $(this).attr('formid');
        console.log(form_number);
        
        $('.toggle-form[formid='+form_number+']').addClass('active');
    });*/
    
    //detect page top
    if($('.header-style-3-nav')[0]) {    
        $(window).load(function() {
            if ($(window).scrollTop() >= 50) {
                $('header.fixed-top .header-style-3-nav').addClass('scrolling');
            } else {
                $('header.fixed-top .header-style-3-nav').removeClass('scrolling');
            }
        });
        $(window).scroll(function() {
            if ($(window).scrollTop() >= 50) {
                $('header.fixed-top .header-style-3-nav').addClass('scrolling');
            } else {
                $('header.fixed-top .header-style-3-nav').removeClass('scrolling');
            }
        });
    }
    
    //accordion 
    if($('.accordion')[0]) {
        $('.accordion-heading').click(function() {
            console.log('clicked');
            $('.accordion-content').slideUp();
            $(this).siblings('.accordion-content').slideDown();
        });
    }
    
    
    $('.hero-bkg-slider, .absolute-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1500,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        pauseOnHover:false,
        pauseOnFocus:false,
        autoplaySpeed: 8000,
    }); 
    
    $('.reviews-slick').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        adaptiveHeight: false,
        autoplaySpeed: 5000,
        nextArrow: '<i class="fas fa-arrow-right"></i>',
        prevArrow: '<i class="fas fa-arrow-left"></i>',
    }); 
    
    $('.specials-slick').slick({
        dots: false,
        infinite: true,
        speed: 200,
        fade: true,
        cssEase: 'linear',
        autoplay: false,
        pauseOnHover:false,
        pauseOnFocus:false,
        autoplaySpeed: 3500,
        arrows: true,
        slidesToShow: 1,
        adaptiveHeight:true,
        slidesToScroll: 1,
        nextArrow: '<i class="fas fa-arrow-right"></i>',
        prevArrow: '<i class="fas fa-arrow-left"></i>',
    });
    
    $('.gallery-slick').slick({
        dots: false,
        infinite: true,
        speed: 200,
        fade: true,
        cssEase: 'linear',
        autoplay: false,
        pauseOnHover:false,
        pauseOnFocus:false,
        autoplaySpeed: 3500,
        arrows: true,
        slidesToShow: 1,
        adaptiveHeight:true,
        slidesToScroll: 1,
        nextArrow: '<i class="fas fa-arrow-right"></i>',
        prevArrow: '<i class="fas fa-arrow-left"></i>',
    });
    
    $('.gallery-feed-slick').slick({
      dots: false,
      infinite: true,
      speed: 200,
      fade: true,
      cssEase: 'linear',
      autoplay: false,
      pauseOnHover:false,
      pauseOnFocus:false,
      autoplaySpeed: 3500,
      arrows: true,
      slidesToShow: 1,
      adaptiveHeight:true,
      slidesToScroll: 1,
      nextArrow: '<i class="fas fa-arrow-right"></i>',
      prevArrow: '<i class="fas fa-arrow-left"></i>',
    });
    
    
    function toggleDropdown (e) {
      let _d = $(e.target).closest('.dropdown'),
          _m = $('.dropdown-menu', _d);
      setTimeout(function(){
        let shouldOpen = e.type !== 'click' && _d.is(':hover');
        _m.toggleClass('show', shouldOpen);
        _d.toggleClass('show', shouldOpen);
        $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
      }, e.type === 'mouseleave' ? 50 : 0);
    }
    
    $(window).on('load resize', function() {
        var viewport_window = $(window).width();
    
        if(viewport_window > 991) {
            $('body')
              .on('mouseenter mouseleave','.dropdown',toggleDropdown)
              .on('click', '.dropdown-menu a', toggleDropdown);
        }
    });


});


// WEBPACK FOOTER //
// ./scripts/mta.js